export const markerAlpha = '.6'
